import { useEffect, useState } from "react";
import { getUiVersion, subscribeUiVersion, UiVersion } from "../../uiVersion";

// Re-renders the shell when the banner flips the version, so the switch is a
// client-side tree swap instead of a full page reload.
export function useUiVersion(): UiVersion {
    const [version, setVersion] = useState<UiVersion>(getUiVersion);
    useEffect(() => subscribeUiVersion(() => setVersion(getUiVersion())), []);
    return version;
}
